import React from 'react';
import { List, Popup } from 'semantic-ui-react';
import FixedIcon from './FixedIcon';

const InformationItem = props => {
  return props.content !== null ? (
    <Popup
      trigger={
        <List.Item>
          <FixedIcon name={props.icon} />
          <List.Content>{props.content}</List.Content>
        </List.Item>
      }
      content={props.info}
      size="mini"
    />
  ) : null;
};

export default InformationItem;



// WEBPACK FOOTER //
// ./src/component/InformationItem.js